module.exports = __webpack_public_path__ + "media/assets/img/screenshots/overview-60c79723a8ea43cc747367b769b40b38.png";